import { Button, Card, Form, Modal } from 'react-bootstrap';
import { useHover } from '../../../hooks/useHover';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import { useEffect, useState } from 'react';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { Placeholder } from '../../components/Placeholder/Placeholder';
import { Copyable } from '../../components/Copyable/Copyable';

const AdminAuthorComponent = ({ author, onUpdate }) => {
  const { database, currentUser } = useFirebase();
  const [wrapperName, isHover] = useHover<HTMLDivElement>();
  const [editModalShow, setEditModalShow] = useState(false);
  const [newName, setNewName] = useState('');
  const [authorRenameLoading, setAuthorRenameLoading] = useState(false);

  useEffect(() => {
    if (!setEditModalShow) setNewName(author.name);
  }, [setEditModalShow]);

  useEffect(() => {
    setNewName(author.name);
  }, [author]);

  return (
    <>
      <Card bg={'dark'}>
        <Card.Body className={'d-flex flex-row align-items-center'}>
          <div>
            {!!author.photo ? (
              <img src={author.photo} alt={author.name} style={{ width: '80px', height: '80px', borderRadius: '50%' }} />
            ) : (
              <Placeholder width={80} height={80} round />
            )}
          </div>
          <div className={'ml-2 flex-grow-1'}>
            <div ref={wrapperName} className={'d-flex align-items-center'}>
              <h5 className={'mb-0'}>{author.name}</h5>
              {isHover && (
                <FontAwesomeIcon icon={faPen} color={'grey'} className={'ml-2'} style={{ cursor: 'pointer' }} onClick={() => setEditModalShow(true)} />
              )}
            </div>
            <div>
              <small>
                <Copyable text={author.id} />
              </small>
            </div>
          </div>
        </Card.Body>
      </Card>

      <Modal show={editModalShow} onHide={() => setEditModalShow(false)} backdrop={'static'} keyboard={false}>
        <Modal.Header>
          <Modal.Title>Modifica nome</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Control disabled={authorRenameLoading} value={newName} onChange={(e) => setNewName(e.target.value)} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant={'secondary'} disabled={authorRenameLoading} onClick={() => setEditModalShow(false)}>
            Annulla
          </Button>
          <Button
            variant={'primary'}
            disabled={authorRenameLoading || !newName}
            onClick={() => {
              setAuthorRenameLoading(true);
              database
                .doc(`authors/${author.id}`)
                .set({ name: newName, lastEditBy: currentUser.uid }, { merge: true })
                .then(() => {
                  setEditModalShow(false);
                  onUpdate();
                })
                .catch(console.error)
                .finally(() => setAuthorRenameLoading(false));
            }}
          >
            Conferma
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export { AdminAuthorComponent as AdminAuthor };
